<template>
  <div class="items">
    <div class="item_body_keyword">
      {{ item.keyword }}
    </div>
    <div
      class="item_body_link"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
    >
      <a
        v-if="item.url"
        :href="item.url"
        class="l-side-logo__link c-link--blank"
        target="_blank"
      >
      </a>
      <a
        :href="item.url"
        class="c-link--popover"
        :class="{ 'is-visible': this.isVisible }"
        target="_blank"
      >
        {{ removeDomainUrl }}
      </a>
    </div>
    <div class="item_body_category">
      <p :class="categoryCssClass">
        {{ category }}
      </p>
    </div>
    <div class="item_body_button">
      <Button
        variant="main"
        size="w180"
        fsize="f12"
        @click="taskCompleteModalOpen"
        class="c-button--completeTask"
      >
        タスクを完了する
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: false
    }
  },

  components: {
    Button
  },

  data() {
    return {
      isVisible: false
    };
  },
  computed: {
    category() {
      let category = '';

      if (this.categoryLabel[this.item.type]) {
        if (this.item.isProposal) {
          category += '提案 - ';
        }
        category += this.categoryLabel[this.item.type];
      }
      return category;
    },
    categoryCssClass() {
      return {
        'c-list--category__item': true,
        ['c-list--category__item--' + this.item.type]: this.item.type
      };
    },
    categoryLabel() {
      return this.$store.getters['task/solutionLabel'];
    },
    removeDomainUrl() {
      return this.$options.filters.removeDomain(
        this.item.url,
        this.project.siteUrl
      );
    }
  },

  methods: {
    taskCompleteModalOpen() {
      this.$emit('taskCompleteModalOpen', this.item);
    },
    mouseenter() {
      this.isVisible = true;
    },
    mouseleave() {
      this.isVisible = false;
    }
  }
};
</script>
